<template>
  <div>
    <div class="contentArea">
    
      <div v-if="page.type === 'table'">
        <AgGrid />
      </div>
    
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import Banner from "./elements/banner/Banner.vue"

import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
    Banner
  },
  data() {
    return {
      language:null,
      radios2:'primary',
    }
  },
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page",
 
    }),
  },

  async mounted() {
    await this.$store.dispatch("general/getPage_2");

    // this.$store.dispatch("general/getTab", this.nowSlug);
    // this.$store.dispatch("general/getTable",( this.tabActive.path||this.nowSlug));
    // eslint-disable-next-line no-console
    // console.log("page", this.page);
  },
  watch: {
    // tabActive(newValue) {
    //   this.$store.dispatch("general/getTable", newValue.path);
    // }
  },
};
</script>
